import React from 'react';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import {ListAttachTaiLieuRowItem} from 'modules/giai-quyet-don/datatable/rowItem';

class DanhSachTaiLieuDinhKem extends React.Component {
 
  render() {
    return (
      <section className="tldk-block">
        <div className="block-file-attach">
          <h3 className="txt-upper txt-blue title-12 mt10">danh sách Tài liệu đính kèm</h3>
        </div>
        <div className="wrap-big-line white-table">
          <DataTable
            header={header.giaiQuyetDon.danhSachTaiLieuDinhKem}
            dataList = {this.props.listTaiLieuVanThuGiaiQuyetDon}
            type = "list-attach"
            hidePagination={true}
            hiddenButtonExport
          >
            <ListAttachTaiLieuRowItem/>
          </DataTable>
        </div>
      </section>
    );
  }
}

DanhSachTaiLieuDinhKem.defaultProps = {
  listTaiLieuVanThuGiaiQuyetDon: []
}

export default DanhSachTaiLieuDinhKem;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/DanhSachTaiLieuDinhKem.jsx